import { constantRoutes } from '@/router'
import { component } from '@/router/componentMap.js'
import { addNoFlyZone, editNoFlyZone, AutoApproval, taskAchievementDisplay, addTaskArr, editTaskArr, deviceInfoArr } from '@/router/modules/button.js'
/* import path from "path";
import { isExternal } from "@/utils/validate"; */

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 */
export function filterAsyncRoutes(routes) {
    const res = []
    routes.forEach(route => {
        const tmp = { ...route }

        if (tmp.component && component[tmp.component]) {
            tmp.component = component[tmp.component];
        }

        if (tmp.children) {

            /* 任务管理子路由 */
            const isAddTask = tmp.children.some(item => (item.name === 'TaskManage' || item.name === 'MyTask') && item.children && item.children.some(button => button.permission && button.permission.indexOf('add') != -1))
            isAddTask && tmp.children.push(...addTaskArr)
            const isEditTask = tmp.children.some(item => (item.name === 'TaskManage' || item.name === 'MyTask') && item.children && item.children.some(button => button.permission && button.permission.indexOf('edit') != -1))
            isEditTask && tmp.children.push(...editTaskArr)
            // 成果展示
            const isResultsTask = tmp.children.some(item => (item.name === 'TaskManage' || item.name === 'MyTask') && item.children && item.children.some(button => button.permission && button.permission.indexOf('results') != -1))
            isResultsTask && res.push(taskAchievementDisplay)

            /* 审批管理子路由 */
            const isAutoApproval = tmp.children.some(item => item.name === 'ApprovalManage' && item.children && item.children.some(button => button.permission === 'approval:automaticApprovalSet'))
            isAutoApproval && tmp.children.push(AutoApproval)

            /* 禁飞区管理的添加和编辑子路由 */
            const isAddNoFlyZone = tmp.children.some(item => item.name === 'NoFlyZoneManage' && item.children && item.children.some(button => button.permission === 'noFlyZone:add'))
            const isEditNoFlyZone = tmp.children.some(item => item.name === 'NoFlyZoneManage' && item.children && item.children.some(button => button.permission === 'noFlyZone:edit'))
            isAddNoFlyZone && tmp.children.push(addNoFlyZone)
            isEditNoFlyZone && tmp.children.push(editNoFlyZone)

            /* 设备管理子路由 */
            const isDeviceInfo = tmp.children.some(item => item.name === 'DeviceManage' && item.children && item.children.some(button => button.permission === 'device:details'))
            isDeviceInfo && tmp.children.push(...deviceInfoArr)

            tmp.children = filterAsyncRoutes(tmp.children)
        }

        if (tmp.menuType !== 'B') {
            res.push(tmp)
        }

    })

    return res
}

/* function resolvePath(routePath) {
    if (isExternal(routePath.path)) {
        return routePath.path;
    }
    let path = ''
    if (routePath.children && routePath.children.length) {
        path += path.resolve(path, routePath.children[0].path);
    } else {
        return routePath.path;
    }
    return path;
} */

const state = {
    routes: [],
    addRoutes: [],
    buttons: [],
    ptzControl: []
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = constantRoutes.concat(routes)
    },
    SET_BUTTONS: (state, buttons) => {
        state.buttons = buttons || []
    }
}

const actions = {
    generateRoutes({ commit }, asyncRoutes) {
        return new Promise(resolve => {
            let accessedRoutes = filterAsyncRoutes(asyncRoutes)
            /* if (accessedRoutes[0]) {
                accessedRoutes.unshift({
                    path: '/',
                    redirect: accessedRoutes[0].path,
                    hidden: true
                })
            } */
            accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
        })
    },
    resetRoutes({ commit }) {
        return new Promise(resolve => {
            commit('SET_ROUTES', [])
            resolve()
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
